const toggleTable = ( element, status ) => {

    const items = element.closest('.tables__table').querySelectorAll('.tables__tr');

    if ( status === 'closed' ) {
        element.dataset.toggle = 'opened';
        element.innerHTML = '- Less details';
    } else {
        element.dataset.toggle = 'closed';
        element.innerHTML = '+ More details';
    }

    for ( let i = 0; i < items.length; i++ ) {
        if ( status === 'closed' && i > 5 ) {
            items[i].style.display = 'block';
        }
        if (status === 'opened' && (i > 5 && i < (items.length - 1))) {
            items[i].style.display = 'none';
        }
    }
}